const state = {
	showMenu : true,
	refresh (){
		setTimeout(()=>{
			window.myScroll && window.myScroll.refresh()
		},200)
	}
}

const mutations = {
	toggleMenu (){
		state.showMenu = !state.showMenu;
	},
}

export default {
	state,
	mutations
}



// WEBPACK FOOTER //
// ./src/storage/vuex/module/toggleMenu.js